import { FlexRow } from '@epam/promo';
import { FlexCell } from '@epam/uui-components';

import { StatisticsCardHeader } from 'components/common';
import { StatisticsData } from '../StatisticsData';
import { StatisticsCardProps } from './StatisticsCard.model';
import css from './StatisticsCard.module.scss';

export const StatisticsCard = ({
  isLoading,
  title,
  tooltip,
  userStatistics = [],
}: StatisticsCardProps) => (
  <FlexCell
    cx={{
      [css['statistics-card__container']]: true,
      'skeleton-loader': isLoading,
    }}>
    <StatisticsCardHeader title={title} tooltip={tooltip} />
    <FlexRow columnGap="18" cx={css['statistics-card__body']} padding="18">
      {userStatistics.map(({ circleTitle, value }) => (
        <StatisticsData key={circleTitle} title={circleTitle} value={value} />
      ))}
    </FlexRow>
  </FlexCell>
);
